import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { supabase } from 'config/supabase'
import { useDispatch } from 'react-redux'
import { updateUserSession } from 'store/actions/auth.action'
import { Auth } from '@supabase/auth-ui-react'
import { ThemeSupa } from '@supabase/auth-ui-shared'
import Image from 'next/image'
import { Dialog, DialogContent } from '@components/ui/dialog'

function AuthModal({ type = 'sign_in', onClose }) {
  const dispatch = useDispatch()
  const { t } = useTranslation('common')

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        dispatch(updateUserSession(session))
        onClose()
      }
    })
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(async (_event, session) => {
      if (session) {
        dispatch(updateUserSession(session))
        onClose()
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent>
        <div className="auth-modal  py-12 px-5 flex flex-col my-auto w-full text-center ">
          <Image
            className="m-auto md:w-[240px] mb-2 w-[170px]"
            src={'/assets/common/StyleyLogo.png'}
            width={240}
            height={61}
            alt="logo"
          />
          <p className=" text-center mt-1 mb-12 text-sm init">{t('auth.head')}</p>
          <Auth
            redirectTo={window.location.href}
            localization={{
              variables: {
                sign_up: {
                  email_label: t('auth.email_label'),
                  password_label: t('auth.password_label'),
                  email_input_placeholder: t('auth.email_input_placeholder'),
                  password_input_placeholder: t('auth.password_input_placeholder'),
                  button_label: t('auth.button_label'),
                  loading_button_label: t('auth.loading_button_label'),
                  social_provider_text: t('auth.social_provider_text'),
                  link_text: t('auth.link_text'),
                  confirmation_text: t('auth.confirmation_text'),
                },
                sign_in: {
                  email_label: t('auth.email_label'),
                  password_label: t('auth.password_label'),
                  email_input_placeholder: t('auth.email_input_placeholder'),
                  password_input_placeholder: t('auth.password_input_placeholder'),
                  button_label: t('auth.button_label-2'),
                  loading_button_label: t('auth.loading_button_label-2'),
                  social_provider_text: t('auth.social_provider_text'),
                  link_text: t('auth.link_text-2'),
                  confirmation_text: t('auth.confirmation_text-2'),
                },
                forgotten_password: {
                  email_label: t('auth.email_label'),
                  password_label: t('auth.password_label'),
                  email_input_placeholder: t('auth.email_input_placeholder'),
                  button_label: t('auth.button_label-3'),
                  loading_button_label: t('auth.loading_button_label-3'),
                  link_text: t('auth.link_text-3'),
                  confirmation_text: t('auth.confirmation_text-3'),
                },
                update_password: {
                  password_label: t('auth.password_label-2'),
                  password_input_placeholder: t('auth.password_input_placeholder-2'),
                  button_label: t('auth.button_label-4'),
                  loading_button_label: t('auth.loading_button_label-4'),
                  confirmation_text: t('auth.confirmation_text-4'),
                },
                verify_otp: {
                  email_input_label: t('auth.email_label'),
                  email_input_placeholder: t('auth.email_input_placeholder'),
                  phone_input_label: t('auth.phone_input_label'),
                  phone_input_placeholder: t('auth.phone_input_placeholder'),
                  token_input_label: t('auth.token_input_label'),
                  token_input_placeholder: t('auth.token_input_placeholder'),
                  button_label: t('auth.button_label-5'),
                  loading_button_label: t('auth.loading_button_label-2'),
                },
              },
            }}
            supabaseClient={supabase}
            style={{
              container: {
                width: '100%',
              },
            }}
            view={type}
            appearance={{ theme: ThemeSupa }}
            providers={['discord', 'google']}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default AuthModal
